import { create} from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '@viome/viome-base/src/usecase/Login/Login.model';

export interface IUserStore {
  user: User | undefined;
  setUser: (userInfo: User | undefined) => void;
}

export const useUserStore = create<IUserStore>()(
  persist(
    (set) => ({
      user: undefined,
      setUser: (userInfo) => set(() => ({ user: userInfo })),
    }),
    { name: 'user-store' }
  ),
);